import { faMagnifyingGlassMinus } from "@fortawesome/pro-regular-svg-icons";
import { useImagePreviewHandlers } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";

/**
 * Zoom Out tool for the ImagePreview toolbox.
 */
export const ZoomOut = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();
    return <Tool icon={faMagnifyingGlassMinus} label="Zoom Out" onClick={handlers.zoomOut} {...props} />;
};
